<template>
    <div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12" md="6">
                <b-form-group
                    :state="$v.valor.$error ? false : null"
                    invalid-feedback="Valor é obrigatório"
                >
                    <label>Valor Total</label>
                    <money
                        v-model="valor"
                        v-bind="$moneyConfig"
                        class="form-control text-right"
                        @input.native="$v.valor.$touch()"
                    ></money>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
                <b-form-group
                    :state="$v.prazoFinal.$error ? false : null"
                    invalid-feedback="Prazo Final é obrigatório"
                >
                    <label class="required">Prazo Final</label>
                    <date-picker
                        v-model="prazoFinal"
                        :config="$datePickerOptions"
                        v-mask="'##/##/####'"
                        @input.native="$v.prazoFinal.$touch()"
                    ></date-picker>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label class="required">Descrição</label>
                    <b-form-textarea
                        v-model="descricao"
                        :rows="2"
                        maxlength="250"
                        @input="$v.descricao.$touch()"
                        :state="$v.descricao.$error ? false : null"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>
                        A descrição é obrigatória
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label :class="{'required': operacaoAtualizacao}">observação</label>
                    <b-form-textarea
                        v-model="observacao"
                        :rows="2"
                        maxlength="250"
                        @input="$v.observacao.$touch()"
                        :state="$v.observacao.$error ? false : null"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>
                        A observação é obrigatória para atualização
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-col>
        </b-row>
        <div class="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                @click.stop="confirmarSalvar()"
                class="ml-1"
                :disabled="desabilitarBtnSalvar"
            >
                Salvar
            </b-button>
        </div>
    </div>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import InvestimentoServicos from './InvestimentoServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        tipoOperacao: {
            type: String,
            default: () => ''
        },

        showModal: {
            type: Boolean,
            default: () => false
        },

        investimento: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            descricao: '',
            valor: 0,
            prazoFinal: new Date(),
            observacao: null
        }
    },

    methods: {
        fecharModal() {
            this.mostrarModal = false
            this.resetFormulario()
            this.$emit('modalFechado')
        },

        resetFormulario() {
            this.erros = [],
            this.descricao = '',
            this.valor = 0,
            this.prazoFinal = new Date(),
            this.observacao = null
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            if (this.operacaoAtualizacao) {
                this.obterInvestimento()
            }
        },

        obterInvestimento() {
            this.$store.dispatch('addRequest')
            InvestimentoServicos.obterInvestimento(
                this.contrato.idContrato,
                this.investimento.idInvestimentoPrevistoContrato
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.descricao = response.data.descricao
                        this.prazoFinal = this.$moment(
                            response.data.prazoFinal
                        ).format('DD/MM/YYYY')
                        this.valor = response.data.valor
                        this.observacao = response.data.observacao
                    } else {
                        this.$toast.error(
                            'Erro ao obter o investimento',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarSalvar() {
            let msg
            if (this.tipoOperacao == 'i') {
                msg = 'Confirma a inserção do Investimento?'
            } else {
                msg = 'Confirma a atualização do Investimento?'
            }

            this.$swal({
                title: 'Investimento',
                html: msg,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let investimentoDto = {
                contratoId: this.contrato.idContrato,
                prazoFinal: this.prazoFinal
                    ? this.$moment(this.prazoFinal, 'DD/MM/YYYY').toISOString()
                    : '',
                descricao: this.descricao,
                valor: this.valor,
                observacao: this.observacao
            }

            let promisse
            if (this.tipoOperacao == 'i') {
                promisse = InvestimentoServicos.inserir(investimentoDto)
            } else {
                investimentoDto = { ...investimentoDto, idInvestimentoPrevistoContrato: this.investimento.idInvestimentoPrevistoContrato }
                promisse = InvestimentoServicos.atualizar(this.contrato.idContrato, this.investimento.idInvestimentoPrevistoContrato, investimentoDto)
            }

            promisse.then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Operação realizada com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterInvestimentosAtualizados')
            this.fecharModal()
        }
    },

    created() {
        this.preencherForm()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        operacaoAtualizacao() {
            return this.tipoOperacao == 'a'
        }
    },

    watch: {
        showModal() {
            this.mostrarModal = this.showModal
        }
    },

    validations: {
        descricao: {
            required
        },

        prazoFinal: {
            required
        },

        valor: {
            required,
            minValue: minValue(0.01)
        },

        observacao: {
            obrigatorio() {
                if (this.operacaoAtualizacao)
                {
                    return this.observacao != null  && this.observacao != ''
                }
                return true
            }
        },
    }
}
</script>
<style scoped>
    .modal-footer {
        justify-content: flex-end;
        padding: 1rem 0 0 0;
        margin: 0.5rem 0 0 0;
        border-top: 1px solid #c8ced3;
    }
</style>
